import { render, staticRenderFns } from "./TargetSKU.vue?vue&type=template&id=518f184a&scoped=true&"
import script from "./TargetSKU.vue?vue&type=script&lang=js&"
export * from "./TargetSKU.vue?vue&type=script&lang=js&"
import style0 from "./TargetSKU.vue?vue&type=style&index=0&id=518f184a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f184a",
  null
  
)

export default component.exports